import { render } from "./StandBy.vue?vue&type=template&id=8e0fbdaa&scoped=true"
import script from "./StandBy.vue?vue&type=script&lang=js"
export * from "./StandBy.vue?vue&type=script&lang=js"

import "./StandBy.vue?vue&type=style&index=0&id=8e0fbdaa&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e0fbdaa"]])

export default __exports__